<template>
    <div class="allchain project-approval-page">
        <!-- 页面标题 -->
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-s-order"></i>
        <h2>上市公司投资项目库</h2>
      </div>
    </div>
        <div class="index_left_centerpage">
            <div class="whitebox right_topbox">
                <div class="right_boxtitle map_title_tab">
                    <!-- ajaxsearchcompany(1) -->
                    <span class="title" @click="routerself('/investSearch?navValue=1')">投资项目检索</span>
                    <span class="title" :class="{ 'current': navValue == list.value }"
                        @click="navValue = list.value; ajaxsearchcompany(1)" v-for="(list) in navList"
                        :key="list.value">{{ list.label }}</span>
                </div>
                <investStatictics class="mt-3" :pageType="navValue" @search="searchList"></investStatictics>
            </div>
            <div class="whitebox">
                <div class="pb-3 pt-2">
                    <table border="0" cellspacing="0" cellpadding="0" class="land_table" v-loading="loading">
                        <tr>
                            <th>名次</th>
                            <th v-show="navValue != 3">{{ navValue == 1 ? '行业' : '区域' }}</th>
                            <th v-show="navValue == 3">企业名称</th>
                            <th v-show="navValue == 3">企业地点</th>
                            <th v-show="navValue == 3">股票代码</th>
                            <th>投资金额（亿元）</th>
                            <!-- <th>投资金额占比</th> -->
                            <th>投资项目数</th>
                            <!-- <th>投资项目数占比</th> -->
                        </tr>
                        <tr v-for="(item, index) in enterpristlist" :key="item.stockCode">
                            <td>{{ (page - 1) * pageSize + index + 1 }}</td>
                            <td v-show="navValue != 3">{{ item.name }}</td>
                            <td v-show="navValue == 3" class="title"
                                @click="routerlinkid('/enterprises', item.stockCode)">{{ item.title }}</td>
                            <td v-show="navValue == 3">{{ item.areaName }}</td>
                            <td v-show="navValue == 3">{{ item.stockCode }}</td>
                            <td>{{ item.money.toFixed(2) }}</td>
                            <!-- <td>{{item.sourceArea}}</td> -->
                            <td>{{ item.num }}</td>
                            <!-- <td>{{item.investArea}}</td> -->
                        </tr>
                    </table>
                </div>
                <!-- 分页 -->
                <div class="pagination-wrapper oh w95mg py-3" v-if="totalPage > 1">
                    <el-pagination class="fr" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="page" :page-sizes="[20]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total" background />
                </div>
                <div class="widthPC-95 margin-x-auto">
                    <h2 class="chart-title">投资金额（亿元）</h2>
                    <div id="charts-box"
                        :style="{ 'height': this.enterpristlist.length < 5 ? '300px' : enterpristlist.length * 50 + 'px' }">
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import investStatictics from "./inc/Statictics.vue";
export default {
    name: 'landSearch',
    components: {
        investStatictics
    },
    computed: {
        ...mapState({
            // isCollapse: (state) => state.app.isCollapse,
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(['isCollapse'])
    },
    data() {
        return {
            title: "报告库",
            curWebsite: this.$api.getWebsiteType(),
            userdata: {},
            yj_itemcode: "E02",
            page: 1, //显示的是哪一页
            haspage: true, //是否还有下一页
            pageSize: 20, //每一页显示的数据条数
            total: 0, //记录总数
            totalPage: 1,
            maxPage: 10, //最大页数 
            enterpristlist: [],
            navList: [
                { value: 1, label: '项目行业分布' },
                { value: 2, label: '项目区域分布' },
                { value: 3, label: '企业统计分析' },
            ],
            navValue: 1,
            searchData: { areaRadio: 1 },
            loading: false,
        }
    },
    created() { },
    mounted() {
        this.navValue = this.$route.query.navValue ? this.$route.query.navValue : 1;
        this.ajaxsearchcompany(1);
    },
    methods: {
        searchList(filterData) {
            //处理一下filterData里面为‘’和0的数据
            for (let key in filterData) {
                if (filterData[key] == '' || filterData[key] == 0) {
                    delete filterData[key];
                }
            }
            this.searchData = filterData;
            this.ajaxsearchcompany(1);
        },
        ajaxsearchcompany(pages) {
            this.page = pages ? pages : 1;
            this.loading = true;
            let params = {
                page: this.page,
                pageSize: this.pageSize,
                ...this.searchData,
                //  thread:this.navValue == 1 ? '0' : '1',
            };
            let ajxurl = this.$api.metall.InvestCount.Industry();
            if (this.navValue == 1) {
                this.$api.metall.InvestCount.Industry();
            } else if (this.navValue == 2) {
                ajxurl = this.$api.metall.InvestCount.Area();
            } else if (this.navValue == 3) {
                ajxurl = this.$api.metall.InvestCount.Enterprise();
            }
            this.$axios.get(ajxurl, { params: params }).then((res) => {
                if (res.success) {
                    this.enterpristlist = res.list;
                    if (this.searchData.areaRadio == 1) {
                        setTimeout(() => {
                            this.rankFun('charts-box', this.enterpristlist);
                        }, 3000);

                    } else if (this.searchData.areaRadio == 2) {
                        setTimeout(() => {
                            this.PiechartFun('charts-box', this.enterpristlist);
                        }, 3000);

                    }
                    this.totalPage = res.totalPage;
                    this.total = res.totalRecord;
                    this.pageSize = res.pageSize;
                    this.loading = false;
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        //饼图fn
        PiechartFun(el, data) {
            console.log('进入饼图');
            var regionalchart = echarts.init(document.getElementById(el));
            for (var i = 0; i < data.length; i++) {
                data[i].value = data[i].money.toFixed(2);
            }
            regionalchart.clear();
            var option = {
                title: {
                    text: ' ',
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                legend: {
                    top: 'center', left: '5%', textStyle: { fontSize: 16, lineHeight: 100 }, orient: 'vertical', icon: 'quadrilateral'
                },
                series: [{
                    name: '投资金额（亿元）',
                    type: 'pie',
                    radius: '55%',
                    // center: ["52%", "50%"],
                    data: data,
                    label: {
                        show: true,
                        fontSize: 16,
                        position: 'outside',
                        formatter: '{b} : {d}%',
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },

                }]
            };
            regionalchart.setOption(option);
        },
        //柱状图
        rankFun(el, data) {
            console.log('进入柱状图');
            var chart = echarts.init(document.getElementById(el));
            var xline = [],
                seriesline = [];
            var datalen = data.length - 1;
            for (var i = 0; i < data.length; i++) {
                xline.push(data[datalen - i].name);
                seriesline.push(data[datalen - i].money.toFixed(2));
            };
            chart.clear();
            var option = {
                legend: {
                    type: 'plain',
                    show: true,
                },
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                },
                xAxis: {
                    type: data.length < 5 ? 'category' : 'value',
                    axisTick: {
                        show: true
                    },
                    // boundaryGap: [0, 0.01],
                    splitLine: {
                        show: true
                    },
                    axisLabel: {
                        fontSize: 16,
                    },
                    data: data.length < 5 ? xline : [],
                },
                yAxis: {
                    type: data.length < 5 ? 'value' : 'category',
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: true
                    },
                    axisLine: {
                        show: true
                    },
                    data: data.length < 5 ? [] : xline,
                    axisLabel: {
                        fontSize: 16,
                    }
                },
                toolbox: { //可视化的工具箱
                    show: true,
                    itemGap: 30,
                    itemSize: 20,
                    // right: '9%',
                    feature: {
                        dataView: { //数据视图
                            show: true,
                            title: '数据视图',
                        },
                        saveAsImage: {//保存图片
                            show: true,
                            title: '保存为图片'
                        },
                    }
                },
                series: [{
                    name: '投资金额(亿元)',
                    data: seriesline,
                    type: 'bar',
                    barWidth: data.length > 10 ? data.length / 2 * 2 : 30,
                    label: {
                        show: true,
                        position: 'right',
                    },
                }]
            };
            chart.setOption(option);
            window.addEventListener('resize', () => {
                chart.resize();  // ECharts 图表重绘
            });
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val
            this.ajaxsearchcompany()
        },

        handleCurrentChange(val) {
            this.page = val
            this.ajaxsearchcompany(val);
        }
    },
}
</script>

<style lang="scss">
.index_left_centerpage {
    .land_table tr td {
        border-bottom: 1px solid #ccc;
    }
}

.projectFormIcon {
    font-size: 18px;
    font-weight: normal;
    margin-bottom: 20px;

    &::before {
        content: '';
        display: inline-block;
        width: 16px;
        height: 16px;
        background-color: #3A568E;
        margin-right: 20px;
        border-radius: 4px;
    }
}

.chart-title {
    font-size: 20px;
    font-weight: bold;
    color: #305ea3;
    padding-bottom: 20px;
    border-bottom: 1px solid #305ea3;
    margin-bottom: 20px;
}

#charts-box {
    width: 100%;
    height: 400px;
    // border: 1px solid #f31010;
    margin: 0 auto;
    padding-bottom: 20px;
}

.collectfont1 {
    font-size: 14px;
    color: #305ea3;
    cursor: pointer;

    &:hover {
        color: #f19d00;
    }
}

.land_table {
    margin: 0 auto;
    border: 1px solid #f2f2f2;
    background: #fff;
    width: 95%;

    .title {
        cursor: pointer;
        color: #305ea3;

        &:hover {
            color: #f19d00;
            text-decoration: underline;
        }
    }

    th {
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        height: 54px;
        line-height: 54px;
        background: #f2f8fe;
        white-space: nowrap;
        padding: 0 10px;
        border-right: 1px solid #dcdcdc;
    }

    tr {
        height: 40px;
        border-bottom: 1px solid #dcdcdc;

        td {
            text-align: center;
            border-right: 1px solid #dcdcdc;
            padding: 0 10px;
        }
    }
}
</style>